import { Route } from '@angular/router';

import { DetailsComponent, MainComponent } from '@asset-solutions/customer-tracking';

export const appRoutes: Route[] = [
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: ':orderId',
        component: DetailsComponent
      }
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
